// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"a494d98f","147":"162e3fa3","186":"a8220d77","187":"492e3f6b","453":"00b8a6fd","745":"ed99b37b","818":"997baa12","995":"bc2add53"}[chunkId] + ".chunk.js";
};